import { ErrorComponentProps } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { Card, CardHeader, CardTitle, CardContent, Button } from "@duck/ui"
import { useTar } from "@/modules/i18n"
import * as Sentry from "@sentry/react"

const isMissingAssetError = (error: Error) => {
    return !!error?.message?.match(/Failed to fetch dynamically imported module: https?:\/\/([\w.]*xp-lab\.com|localhost:\d+)\/assets\/[\w-_.]+\.js/)
}

export const ErrorBoundary = ({ error }: ErrorComponentProps) => {
    const { t } = useTar()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (isMissingAssetError(error)) {
            window.location.reload()
            return
        }
        Sentry.captureException(error)
        setIsLoading(false)
    }, [error])

    if (isLoading) {
        return null
    }

    return (
        <div className="flex h-screen items-center justify-center p-6">
            <Card className="w-full max-w-lg shadow-sm">
                <CardHeader>
                    <CardTitle>{t('common.error')}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-sm text-muted-foreground">
                        {t('common.somethingWentWrongWeveBeenNotified')}
                    </p>
                    <Button onClick={() => window.location.reload()}>{t('common.tryAgain')}</Button>
                </CardContent>
            </Card>
        </div>
    )
}
